import "core-js/modules/es6.array.for-each";
import { parser as systemProps } from "@chakra-ui/parser";
import createStyled from "./create-styled";
import { applyProp, componentProps, domElements, pseudoProps, truncateProp, layerStyleProp } from "./system.utils";

function styled(component, options) {
  return createStyled(component, options)(componentProps(options), systemProps, pseudoProps, applyProp(component), truncateProp, layerStyleProp);
}

export var chakra = styled;
domElements.forEach(function (tag) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  chakra[tag] = chakra(tag);
});